import axios from "axios";

import { getOneAccount } from "api/accounts";
import { AccountType } from "shared/types/accounts";

export async function addInstagramPassword({
  accountId,
  password,
  twoFactorKey,
}: {
  accountId: string;
  password: string;
  twoFactorKey?: string;
}) {
  const response = await axios.request<AccountType>({
    method: "put",
    url: `/accounts/instagram/password/${accountId}`,
    data: { password, twoFactorKey },
  });

  return response.data;
}

export async function updateInstagramPassword({
  accountId,
  password,
}: {
  accountId: string;
  password: string;
}) {
  await axios.request<AccountType>({
    method: "put",
    url: `/accounts/password/${accountId}`,
    data: { password },
  });

  return await getOneAccount(accountId);
}

export async function updateInstagramUsername({
  accountId,
  username,
}: {
  accountId: string;
  username: string;
}) {
  await axios.request<AccountType>({
    method: "put",
    url: `/accounts/username/${accountId}`,
    data: { username },
  });

  return await getOneAccount(accountId);
}

export async function updateIGAccountField({
  accountId,
  field,
  newValue,
}: {
  accountId: string;
  field: "username" | "password";
  newValue: string;
}) {
  switch (field) {
    case "username":
      return await updateInstagramUsername({ accountId, username: newValue });
    case "password":
      return await updateInstagramPassword({ accountId, password: newValue });
  }
}

export async function retryVerifyLogin(accountId: string) {
  await axios.request({
    method: "put",
    url: `/accounts/verify/${accountId}`,
  });
  return await getOneAccount(accountId);
}

export async function verifyChoice({
  accountId,
  choice,
}: {
  accountId: string;
  choice: "email" | "sms";
}): Promise<AccountType> {
  const response = await axios.request<{ account: AccountType }>({
    method: "post",
    url: `/accounts/verifychoice/${accountId}`,
    data: { choice },
  });

  return response.data.account;
}

export async function enterCode({
  accountId,
  code,
}: {
  accountId: string;
  code: string;
}) {
  await axios.request<{ account: AccountType }>({
    method: "post",
    url: `/accounts/verifychoice/${accountId}`,
    data: { code },
  });
}

export function getAccountFromError(err: Error): AccountType | null {
  if (
    axios.isAxiosError(err) &&
    typeof err.response?.data?.account === "object"
  ) {
    return err.response.data.account as AccountType;
  } else {
    return null;
  }
}
